// ============================================================
// AGRIDA — DEBT REMINDER TIMELINE
// Display-only helper reading reminder logs for the loan detail UI. The actual
// reminder scheduling/sending is now owned by the backend's ReminderService cron
// (agrida-adama-backend/src/modules/lending/reminder.service.ts) — this file used to
// also duplicate that as a client-side scheduler, which has been removed.
// ============================================================

import { getReminderLogs } from '@/store';
import type { ReminderThreshold } from '@/types';

// ─── Reminder timeline helper ────────────────────────────────

export interface ReminderTimelineEntry {
  threshold: ReminderThreshold;
  label: string;
  sent: boolean;
  sentAt?: string;
}

export function getDebtReminderTimeline(debtId: string): ReminderTimelineEntry[] {
  const logs = getReminderLogs().filter((r) => r.debtId === debtId);

  const labelMap: Record<ReminderThreshold, string> = {
    '7d': 'T-7 ngày',
    '3d': 'T-3 ngày',
    '1d': 'T-1 ngày',
    '12h': 'T-12 giờ',
    '6h': 'T-6 giờ',
    '1h': 'T-1 giờ',
    'due': 'Đến hạn',
    'overdue': 'Quá hạn',
  };

  const thresholds: ReminderThreshold[] = ['7d', '3d', '1d', '12h', '6h', '1h', 'due', 'overdue'];

  return thresholds.map((th) => {
    const log = logs.find((l) => l.threshold === th && l.status === 'sent');
    return {
      threshold: th,
      label: labelMap[th],
      sent: !!log,
      sentAt: log?.sentAt,
    };
  });
}
